// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3NI_i","validationTips":"StatementDescriptor_validationTips__1z8cQ"};